<template>
  <div class="flex shrink-0 flex-row gap-2 px-6">
    <div class="w-2/3">
      <BaseSearchInput v-model="terms" />
    </div>
    <div class="w-1/3">
      <slot name="top-left-cta" />
    </div>
  </div>
  <div class="flex min-h-0 flex-1 flex-col">
    <div class="flex shrink-0 flex-col gap-2 px-6 pb-4">
      <h4 class="font-bold">{{ $t('global.already_chosen') }}</h4>
      <div class="-mx-4 flex max-h-[20vh] flex-col overflow-y-auto px-4">
        <template
          v-for="materialResource in selectedMaterialResources"
          :key="materialResource.id"
        >
          <slot name="user-panel" :material-resource="materialResource">
            <MaterialResourceSelectItem
              :item="materialResource"
              :event="event"
              :is-selected="true"
              :all-material-resources-availability-items="allMaterialResourcesAvailabilityItems"
              @remove-item="removeMaterialResource"
            />
          </slot>
        </template>
      </div>
    </div>
    <div
      class="flex min-h-0 flex-1 flex-col gap-2 border-t bg-gray-100 px-6 pt-2"
    >
      <h4 class="font-bold">{{ $t('global.not_yet_chosen') }}</h4>
      <div class="-mx-4 flex flex-col overflow-y-auto px-4">
        <template
          v-for="materialResource in selectableMaterialResources"
          :key="materialResource.id"
        >
          <MaterialResourceSelectItem
            :item="materialResource"
            :event="event"
            :is-selected="false"
            :all-material-resources-availability-items="allMaterialResourcesAvailabilityItems"
            @add-item="addMaterialResource"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import UserAvatar from '@c/Avatar/UserAvatar.vue'
import BaseSearchInput from '@c/addf-package/components/BaseInput/BaseSearchInput.vue'
import SelectComponent from '@c/BaseFormComponent/SelectComponent.vue'
import { mapGetters } from 'vuex'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import MaterialResourceAvatar from '@c/Avatar/MaterialResourceAvatar.vue'
import MaterialResourceSelectItem from '@c/BaseSelectorComponent/UserSelectorModal/MaterialResourceSelectItem.vue'

export default defineComponent({
  name: 'MaterialResourcesPanel',
  components: {
    MaterialResourceSelectItem,
    MaterialResourceAvatar,
    BaseButton,
    SelectComponent,
    BaseSearchInput,
    UserAvatar
  },
  props: {
    event: {
      type: Object,
      required: false,
      default: () => ({})
    },
    selectedMaterialResources: {
      type: Array,
      required: true
    },
    filter: {
      type: Function,
      required: false,
      default: undefined
    },
    editionMode: {
      type: Boolean,
      required: false,
      default: false
    },
    allUsersAvailabilityItems: {
      type: Array,
      required: false,
      default: () => []
    },
    allMaterialResourcesAvailabilityItems: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  emits: ['add-material-resource', 'remove-material-resource'],
  data() {
    return {
      terms: ''
    }
  },
  computed: {
    ...mapGetters({
      material_resources: 'metadata/getMaterialResourcesMetadata'
    }),
    selectedMaterialResourcesIds() {
      return this.selectedMaterialResources.map((user) => user.id)
    },
    selectableMaterialResources() {
      return this.material_resources
        .filter((user) => !this.selectedMaterialResourcesIds.includes(user.id))
        .filter((material) => {
          const name = material.name?.[this.$i18n.locale]

          if (!name || !this.terms) {
            return true
          }

          return this.$h.normalizeSearch(name).includes(this.$h.normalizeSearch(this.terms))
        })
        .filter(
          (user) => typeof this.filter !== 'function' || this.filter(user)
        )
    }
  },
  methods: {
    addMaterialResource(materialResource) {
      this.$emit('add-material-resource', materialResource.id)
    },
    removeMaterialResource(materialResource) {
      this.$emit('remove-material-resource', materialResource.disponibility.id)
    }
  }
})
</script>

<style scoped></style>
